/**
*
* AccountStatus
*
*/

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';
import { Card } from 'react-bootstrap';
import UserText from 'components/media/UserText/Loadable.js';
import { useApi2call } from 'containers/Api2/index.js';
import { mapIban } from 'components/interaction/InputIban/helpers.js';
import Spinner from 'components/Spinner/index.jsx';
import EditButton from 'components/interaction/EditButton.js';
import IconButton from 'components/interaction/IconButton/index.jsx';
import MollieStatus from './MollieStatus.jsx';
import MollieAlert from './MollieAlert.jsx';
import AccountModal from './AccountModal.jsx';
import AccountRoles from './AccountRoles.jsx';

const Wrapper = styled.div`
  width: 42px;
  height: 30px;
`;

function AccountStatus(props) {
  const { account, active } = props;
  const { name, iban, id, mollieOrganizationId, mollieProfileId } = account;
  const mollie = { organizationId: mollieOrganizationId, profileId: mollieProfileId, ...account.mollie };
  const api2call = useApi2call();
  const [working, setWorking] = useState(false);
  const [showAccount, setShowAccount] = useState(false);
  const classList = classNames(['border p-4', { 'bg-light': active }]);
  const connected = mollie?.status === 'completed';

  function handleRefresh() {
    setWorking(true);
    api2call({ url: `sa/bankaccounts/${id}/mollie`, version: 2, refresh: true, withPromise: true })
      .finally(() => setWorking(false));
  }

  function getControl() {
    if (working) {
      return <Spinner className="mt-n1" size="18px" />;
    }
    if (!connected) {
      return <IconButton variant="link" icon="ss-refresh" className="py-0" onClick={handleRefresh} />;
    }
    return null;
  }

  const control = getControl();
  return (
    <Card className={classList}>
      <div className="d-flex flex-wrap align-items-baseline">
        <div className="flex-grow-1">
          <UserText inline className="fw-semibold me-sm-3">{name}</UserText>
          <div className="d-block d-sm-inline text-nowrap" data-testid="iban">
            <code>
              {mapIban(iban, (str) => <span key={str} className="me-2">{str}</span>)}
            </code>
            <EditButton onClick={() => setShowAccount(true)} />
          </div>
        </div>
        <div className="me-2">
          <MollieStatus mollie={mollie} accountId={id} />
        </div>
        {control && <Wrapper>{control}</Wrapper>}
      </div>
      <MollieAlert mollie={mollie} className="mt-4 d-flex justify-content-center align-items-baseline" />
      <AccountModal show={showAccount} onHide={() => setShowAccount(false)} account={account} />
      <AccountRoles account={account} />
    </Card>
  );
}

AccountStatus.propTypes = {
  account: PropTypes.object,
  active: PropTypes.bool,
};

export default AccountStatus;
